import { useEffect, useState } from 'react';

interface UseDesignerImagesParams {
  userInput?: string;
  createImageMutation: (variables: {
    prompt: string;
  }) => Promise<{ imageUrl: string }>;
}

interface UseDesignerImagesResult {
  designImage1: string | null;
  designImage2: string | null;
  isLoadingDesignImages: boolean;
  setDesignImage1: React.Dispatch<React.SetStateAction<string | null>>;
  setDesignImage2: React.Dispatch<React.SetStateAction<string | null>>;
  setIsLoadingDesignImages: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useDesignerImages = ({
  userInput,
  createImageMutation,
}: UseDesignerImagesParams): UseDesignerImagesResult => {
  const [designImage1, setDesignImage1] = useState<string | null>(null);
  const [designImage2, setDesignImage2] = useState<string | null>(null);
  const [isLoadingDesignImages, setIsLoadingDesignImages] = useState(false);

  useEffect(() => {
    if (userInput && !isLoadingDesignImages && !designImage1 && !designImage2) {
      setIsLoadingDesignImages(true);

      Promise.all([
        createImageMutation({ prompt: userInput }),
        createImageMutation({ prompt: userInput }),
      ])
        .then(([image1Result, image2Result]) => {
          setDesignImage1(image1Result.imageUrl);
          setDesignImage2(image2Result.imageUrl);
        })
        .catch((error) => {
          console.error('Failed to generate designer images:', error);
        })
        .finally(() => {
          setIsLoadingDesignImages(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userInput,
    isLoadingDesignImages,
    designImage1,
    designImage2,
    // createImageMutation is a stable mutation function, doesn't need to be in deps
  ]);

  return {
    designImage1,
    designImage2,
    isLoadingDesignImages,
    setDesignImage1,
    setDesignImage2,
    setIsLoadingDesignImages,
  };
};
